module.exports = __webpack_public_path__ + "img/lexus.e3fc529f.jpg";